import styled from "@emotion/styled";

export const Background = styled.div({
  position: "fixed",
  bottom: 0,
  right: 0,
  width: "100vw",
  height: "200vh",
  backgroundColor: "#ab577e",
});
